import { gql } from '@apollo/client';

export interface OptimizationReport {
  reportId: string;
  jobId: string;
  reportType: string;
  reportStatus: string;
  clientName: string;
  projectName: string;
  targetGroupName: string;
  startedAt: string;
  passedQa: boolean;
  parentJobId: string;
  params: any;
}

export interface OptimizationReportsByParentJobIdResponse {
  allReportJobs: {
    nodes: OptimizationReport[];
  };
}

//AIPD-885 query to get opt reports for a given parent job id
export default gql`
  query OptimizationReportsByParentJobId(
    $parentJobId: UUID!
    $orderBy: [ReportJobsOrderBy!]
  ) {
    allReportJobs(
      condition: { parentJobId: $parentJobId, reportStatus: SUCCESS }
      filter: { reportType: { equalTo: "optimization" } }
      orderBy: $orderBy
    ) {
      nodes {
        reportId
        jobId
        reportType
        reportStatus
        clientName
        projectName
        targetGroupName
        startedAt
        passedQa
        parentJobId
        params
      }
    }
  }
`;
